var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navigation'),_c('toolbar'),_c('v-content',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }